import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getSelectedBusinessClasses } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Arrays from "utils/Arrays";
import AutoCompleteInput from "nlib/ui/AutoCompleteInput";
import Badge from "nlib/ui/Badge";
import Constants from "const/Constants";
import Objects from "utils/Objects";
import React, { useCallback, useMemo, useState } from "react";

const SelectClassInput = (props) => {
  const { uiTexts } = useSelector(getTextsData);

  const {
    value = {},
    code,
    validate,
    placeholder = uiTexts.selectClass,
    onChange,
    ...restProps
  } = props;

  const [showAll, setShowAll] = useState(false);

  const { name: className = "" } = value;

  const classes = useSelector(getSelectedBusinessClasses);

  const items = useMemo(() => {
    return [...classes]
      .sort(({ name: nameA, categoryName: categoryNameA = "" }, { name: nameB, categoryName: categoryNameB = "" }) => {
        return categoryNameA.localeCompare(categoryNameB) || nameA.localeCompare(nameB);
      })
      .map(({ id, name, categoryName }) =>
        ({ value: id, label: name, categoryName: categoryName || uiTexts.class }));
  }, [uiTexts, classes]);

  const filteredItems = useMemo(() => {
    if (!className || showAll) return items;

    const localValue = className.trim().toLowerCase();

    return items.filter((item) => {
      if (!item.label) return false;

      const itemValue = item.label.trim().toLowerCase();

      if (itemValue === localValue || itemValue.includes(localValue)) {
        return true;
      }

      return Objects.checkSimilarityBy(
        { value: className },
        { value: item.label },
        Constants.DATA_SIMILARITY_COEFFICIENT
      );
    });
  }, [className, showAll, items]);

  const renderLabel = useCallback(({ label, categoryName }) => {
    return (
      <div className={Css.listItem} title={label}>
        <span className={Css.name}>{label}</span>
        <Badge className={Css.badge}>{categoryName}</Badge>
      </div>
    );
  }, []);

  const handleChange = useCallback((newName, event) => {
    onChange({ name: newName }, event);
  }, [onChange]);

  const handleAutoComplete = useCallback((item, event) => {
    onChange(Arrays.findById(classes, item.value), event);
  }, [classes, onChange]);

  return (
    <AutoCompleteInput
      {...(validate ? {
        valid: !!(value.name && value.id),
        invalid: !!(value.name && !value.id)
      } : {})}
      {...restProps}
      placeholder={placeholder}
      iconBefore={Icons.Stack}
      iconBeforeTitle={uiTexts.class}
      value={className}
      showAll={showAll}
      renderLabel={renderLabel}
      items={items}
      filteredItems={filteredItems}
      onSetShowAll={setShowAll}
      onChange={handleChange}
      onAutoComplete={handleAutoComplete} />
  );
};

export default React.memo(SelectClassInput);
